if (!window.BytePdpWishlist) {
  const BUTTON_SELECTOR = '.byte-wishlistify-product-page';
  const OVERLAY_CLASS = 'byte-pdp-wishlist';
  const INLINE_CLASS = 'byte-pdp-wishlist--inline';

  class BytePdpWishlist {
    constructor(productInfo) {
      this.productInfo = productInfo;
      this.overlay = null;
      this.observer = null;
    }

    init() {
      this.#sync();
      this.#observe();
    }

    get #mediaList() {
      return this.productInfo.querySelector('.product__media-list');
    }

    #sync() {
      const button = this.productInfo.querySelector(BUTTON_SELECTOR);
      if (button) this.overlay = button.closest('.shopify-app-block') || button;
      if (!this.overlay) return;

      const target = this.#activeMediaContainer();

      this.overlay.classList.toggle(INLINE_CLASS, !target);
      if (!target || this.overlay.parentElement === target) return;

      this.overlay.classList.add(OVERLAY_CLASS);
      target.appendChild(this.overlay);
    }

    #activeMediaContainer() {
      const mediaList = this.#mediaList;
      const activeMedia =
        mediaList?.querySelector('.product__media-item.is-active') ||
        mediaList?.querySelector('.product__media-item');

      return activeMedia?.querySelector('.product-media-container');
    }

    #observe() {
      this.observer = new MutationObserver(() => this.#sync());
      this.observer.observe(this.productInfo, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class'],
      });
    }
  }

  window.BytePdpWishlist = BytePdpWishlist;

  const initBytePdpWishlist = () => {
    document.querySelectorAll('product-info').forEach((productInfo) => {
      new BytePdpWishlist(productInfo).init();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBytePdpWishlist, { once: true });
  } else {
    initBytePdpWishlist();
  }
}
